module.exports = __webpack_public_path__ + "static/media/logo-yellow.595d9c70.svg";